import { render, staticRenderFns } from "./Statistics_V2.vue?vue&type=template&id=7adc3996"
import script from "./Statistics_V2.vue?vue&type=script&lang=js"
export * from "./Statistics_V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports